import ListNewsletter from '../../containers/NewsletterSubscriptions/List';

const newsletterRoutes = [
  {
    path: "/newsletter-subscriptions",
    exact: true,
    auth: true,
    component: ListNewsletter
  }
];

export default newsletterRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/newsletter.jsx